"use client";

import { useClickOutside } from "@/hooks";
import React, { useRef } from "react";

interface DropdownProps {
  open: boolean;
  onClose: () => void;
  className?: string;
  children: React.ReactNode;
  toggleRef?: React.RefObject<HTMLElement | null>;
}

const Dropdown: React.FC<DropdownProps> = ({
  open,
  onClose,
  className = "",
  children,
  toggleRef,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  useClickOutside(ref, onClose, open, toggleRef);

  if (!open) return null;

  return (
    <div ref={ref} className={className} role="menu" aria-hidden={!open}>
      {children}
    </div>
  );
};

export default Dropdown;
